import React from 'react';

import BaseComponent from '../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import SelectCompanyComboBox from '../../../components/SelectCompanyComboBox';
import DataSource from '../../../dao/DataSource/DataSource';
import './CompanyDataCollector.scss';

class CompanyDataCollector extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      vendor_companies: [],
      addCompany: false,
    };
  }

  handleUpdateCompany(company) {
    let vendor_companies = !company.vendor_companies ? [] : company.vendor_companies.map(vc => {
      return vc;
    });
    this.setState({ company, vendor_companies });  
  }

  componentDidMount() {
    super.componentDidMount(this);
    this.companyDataSource = new DataSource('Company', this.props.company.id, { company: { vendor_companies: {} } }, this.handleUpdateCompany);
    this.companyDataSource.get();
  }

  componentWillUnmount() {
    if (this.companyDataSource) {
      this.companyDataSource.release();
      this.companyDataSource = null;
    }
  }

  handleMultipleSelection(multipleSelections, selectedOption) {
    const company = selectedOption.company;
    if (company) {
      let vendor_companies = this.state.vendor_companies;
      if (selectedOption.selected) {
        const findVendor = vendor_companies ? vendor_companies.filter(vendor => {
          return vendor.id == company.id;
        }) : [];
        if (findVendor.length == 0) {
          company.toBeAdded = true;
          vendor_companies.push(company);
        }
        else {
          delete findVendor[0].toBeDeleted;
        }
      }
      else {
        let removeIndex = -1;
        const findCompany = vendor_companies ? vendor_companies.filter((vendor, index) => {
          if (vendor.id == company.id && company.toBeAdded) {
            removeIndex = index;
          }
          return vendor.id == company.id && company.toBeAdded;
        }) : [];
        if (findCompany.length > 0 && findCompany[0].toBeAdded) {
          vendor_companies.splice(removeIndex, 1);
        }
        else {
          company.toBeDeleted = true;
          vendor_companies.filter(vendor =>{
            if (company.id == vendor.id) {
              vendor.toBeDeleted = true;
              return true;
            }
            else {
              return false;
            }
          });
        }
      }
      if (this.props.selectVendorCompanies) {
        this.props.selectVendorCompanies(vendor_companies);
      }
      this.setState({ vendor_companies: vendor_companies });
    }
  }

  render() {

    const { companies } = this.props;
    if (!this.state.company) {
      return null;
    }

    const filteredVendorCompanies = this.state.vendor_companies.filter(vendor => {
      return !vendor.toBeDeleted;
    });
    return (
      <div className="data-collector-container" id={this.props.id}>

        <div className="company-name-title">Select/Deselect Companies</div>
        <div className="company-name-input field">
          <SelectCompanyComboBox id={'select-vendor-company-combobox'} key={'select-vendor-company-combobox'} width={218}
            hasBorder={false} multiSelect={true} showSearchBar={true}
            noBackground={false} initialValue="Select a Company" menuBelow={true}
            handleMultipleSelection={this.handleMultipleSelection} selectedCompanies={filteredVendorCompanies} adjustHeight={false}
            companies={companies} />
        </div>
      </div>);
  }
}

export default (CompanyDataCollector);



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/CompanyDataCollector/index.js